import { Controller } from "stimulus";
import { openModal } from "../modal/utils";


export default class extends Controller {
  static targets = ["btn", "expandedBlock", "expandedBlockDesktop", "modal"];

  expandBlock() {
    this.btnTarget.classList.toggle('rotate');
    this.expandedBlockTarget.classList.toggle('opened');
    this.expandedBlockDesktopTarget.classList.toggle("opened");
  }

  openCalendar(event) {
    if (!this.hasModalTarget) return;
    event.preventDefault();
    event.stopPropagation();
    openModal(this.modalTarget);
  }

  onSelectDates(event) {
    const { checkin, checkout } = event.detail || {};
    const coupon = this.element.dataset.coupon;
    if (!checkin || !checkout || !coupon) return;

    const url = new URL(`/offer/${encodeURIComponent(coupon)}`, window.location.origin);
    url.searchParams.set("checkin", checkin);
    url.searchParams.set("checkout", checkout);
    window.location.href = url.toString();
  }
}
